import {
    Exercise,
    LabelBody,
    LabelHeader4,
    SecondaryButton,
    Spacer,
} from '../components';
import { ExerciseStatus, UpdateExerciseHandler } from '../interfaces';

type Props = {
    children: React.ReactNode;
    onContinue: UpdateExerciseHandler;
};
export function ModuleCompletedView({ children, onContinue }: Props) {
    return (
        <Exercise title="" className="clouds text-center">
            <Spacer />
            <LabelHeader4>Godt arbejde!</LabelHeader4>
            <LabelBody class="mt-10">{children}</LabelBody>
            <Spacer class="mt-30" />
            <SecondaryButton
                onClick={() =>
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                    })
                }
            >
                Afslut
            </SecondaryButton>
        </Exercise>
    );
}
